import Resource from '@/api/resources/Resource'

class PortionPrintService extends Resource {
    async prepareCassettePrintLabel(labId, casId, samId, portion, magazine) {
        const params = {
            magazine: magazine
        }
        return this.axios.put(`/common/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/printCassetteLabel`,
            portion,
            { params })
            .then(response => response.data)
    }

    async prepareCassettePrintLabelForPrintMate(labId, casId, samId, portion, magazine) {
        const params = {
            magazine: Number(magazine)
        }
        return this.axios.put(`/common/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/printPrintMateCassetteLabel`,
            portion,
            { params })
            .then(response => response.data)
    }
}

export default new PortionPrintService()
